<template>
  <div>
    <Card>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'reset_password',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>
